import React from "react";
import {Grid, Tooltip, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import {format, formatDistance, formatRelative, intervalToDuration, parseISO, subDays} from 'date-fns'
import {renderMilisecondsToTimeDuration} from "../../utils/datetimehelp";
import {useSelector} from "react-redux";


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    areaOSKPI:{
      display: 'flex',
      alignContent: 'center',
      alignSelf: 'center',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '5px'
    },
    shape: {
        display: 'inline-block',
        backgroundColor: 'blue', // theme.palette.primary.main,
        width: 10,
        height: 10,
    },
    shapeCircle: {
        borderRadius: '50%',
    },
    texto: {
        textAlign: 'center',
    }
}));


const OSKPI = ({ titulo, valor, cor } ) => {
    const forecolor = cor? { 'color': cor} : {}
    const classes = useStyles();
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);


    return (
        <React.Fragment>
            <Grid container className={classes.areaOSKPI} item xs={2} lg={2} xl={2}>
                <Grid container direction="column"  >
                    <Grid item className={classes.texto}>
                        <Typography variant="caption">{titulo}</Typography>
                    </Grid>
                    <Grid item className={classes.texto}>
                        <Typography style={forecolor} variant="h4">{valor}</Typography>
                    </Grid>
                </Grid>

            </Grid>

        </React.Fragment>
    );
}

export default OSKPI;
